import { motion } from "motion/react";
import { SweepButton } from "./HomepagePrimitives";

type HomepageNavbarSectionProps = {
  onGetCustomQuote?: () => void;
};

/**
 * Structural sticky navbar for the TripboxCRM homepage.
 * @param props Optional quote CTA handler
 * @returns Navbar section
 */
export const HomepageNavbarSection = ({ onGetCustomQuote }: HomepageNavbarSectionProps) => {
  return (
    <motion.header
      id="navbar"
      className="sticky top-0 z-50 border-b border-gray-200 bg-white"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 400, damping: 30 }}
    >
      <div className="mx-auto grid min-h-16 max-w-7xl grid-cols-[1fr_auto] items-center gap-6 px-4 sm:px-6 lg:grid-cols-[1fr_auto_1fr]">
        <a href="/" className="inline-flex items-center gap-3 text-[#131B2A]">
          <img alt="TripboxCRM" src="/logo_text_black.png" className="h-8 w-auto sm:h-9" />
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-1 text-sm font-medium text-[#131B2A]/72 md:flex">
          {[
            { href: "/", label: "Home" },
            { href: "/features", label: "Features" },
            { href: "/security", label: "Security" },
            { href: "/about", label: "About Us" },
          ].map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="rounded-lg px-3 py-2 !text-[#131B2A]/72 no-underline transition-colors duration-150 hover:bg-[#F9FAFB] hover:!text-[#131B2A]"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center justify-end gap-3">
          <a
            href="/login"
            className="inline-flex min-h-11 items-center justify-center rounded-lg border border-gray-200 bg-white px-5 text-sm font-semibold !text-[#131B2A] no-underline shadow-none transition-colors duration-150 hover:border-[#131B2A]/25 hover:bg-[#F9FAFB]"
          >
            Sign in
          </a>
          <SweepButton
            href="/#final-cta"
            tone="navy"
            className="min-h-11 px-5 no-underline max-sm:hidden"
            onClick={
              onGetCustomQuote
                ? (event) => {
                    event.preventDefault();
                    onGetCustomQuote();
                  }
                : undefined
            }
          >
            Get Custom Quote
          </SweepButton>
        </div>
      </div>
    </motion.header>
  );
};
